module.exports = __webpack_public_path__ + "static/assets/a3554d4b0644195e0f9146377eb19e44.svg";